<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="学员姓名"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='学员头像'>
              <va-file-upload
                type='single'
                v-model='insertData.avatarArr'
                @input="uploadAvatarImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.background"
              label="学员背景"
              removable
              :messages="message"
              :error="!!error.backgroundErrors.length"
              :error-messages="error.backgroundErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.joinedProject"
              label="参与项目"
              removable
              :messages="message"
              :error="!!error.joinedProjectErrors.length"
              :error-messages="error.joinedProjectErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.offer"
              label="项目收获"
              removable
              :messages="message"
              :error="!!error.offerErrors.length"
              :error-messages="error.offerErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <div class='flex md6 sm6 xs12' v-show="insertData.offerImageUrl.length!==0">
              <va-card
                overlay
                :image='insertData.offerImageUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class='flex md6 sm6 xs12'>
              <va-card title='offer证明小图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.offerImageArr'
                  @input="uploadOfferImage"
                />
              </va-card>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <div class='flex md6 sm6 xs12' v-show="insertData.offerOriginalImageUrl.length!==0">
              <va-card
                overlay
                :image='insertData.offerOriginalImageUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class='flex md6 sm6 xs12'>
              <va-card title='offer证明大图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.offerOriginalImageArr'
                  @input="uploadOfferOriginalImage"
                />
              </va-card>
            </div>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import uploadApi from '../../api/upload'
import studentOfferApi from '../../api/studentOffer'
import { copyObject } from '../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        avatar: '',
        avatarArr: [],
        background: '',
        joinedProject: '',
        offer: '',
        offerImageArr: [],
        offerImageUrl: '',
        offerOriginalImageArr: [],
        offerOriginalImageUrl: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        backgroundErrors: [],
        joinedProjectErrors: [],
        offerErrors: [],
        sortNumErrors: [],
      },
      title: '新增学员offer',
      showId: false,
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    if (params.id != null) {
      this.showId = true
      this.title = '编辑学员offer'
      // 通过id获取详情
      studentOfferApi.getStudentOffer(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.backgroundErrors.length &&
          !this.error.joinedProjectErrors.length &&
          !this.error.offerErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.avatar.length === 0 || this.insertData.offerImageUrl.length === 0 || this.insertData.offerOriginalImageUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        avatar: this.insertData.avatar,
        background: this.insertData.background,
        joinedProject: this.insertData.joinedProject,
        offer: this.insertData.offer,
        offerImageUrl: this.insertData.offerImageUrl,
        offerOriginalImageUrl: this.insertData.offerOriginalImageUrl,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id != null) {
        studentOfferApi.updateStudentOffer(this.insertData.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'studentOffer' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        studentOfferApi.saveStudentOffer(data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'studentOffer' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          console.log(error)
        })
      }
    },
    clickCancel () {

    },
    uploadAvatarImage () {
      if (this.insertData.avatarArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.avatarArr[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.avatar = response.url
      })
    },
    uploadOfferImage () {
      if (this.insertData.offerImageArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.offerImageArr[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.offerImageUrl = response.url
      })
    },
    uploadOfferOriginalImage () {
      if (this.insertData.offerOriginalImageArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.offerOriginalImageArr[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.offerOriginalImageUrl = response.url
      })
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.backgroundErrors = this.insertData.background ? [] : ['background is required']
      this.error.joinedProjectErrors = this.insertData.joinedProject ? [] : ['joinProject is required']
      this.error.offerErrors = this.insertData.offer ? [] : ['offer is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>
<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
